<template>
    <div class="row m-2">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <p>Saya yang bertanda tangan di bawah ini:</p>
                </div>
                <div v-if="PasienInformation && Object.keys(PasienInformation).length > 0" class="col-12">
                    <table class="table table-borderless">
                        <tr>
                            <td class="text-capitalize pl-0 fw-600" style="width: 20%">nama</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ PasienName }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fw-600" style="width: 20%">no. rekam medis</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ PasienMRN }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fw-600" style="width: 20%">tanggal lahir</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ SuratPersetujuanDate(PasienDateBirth) }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fw-600" style="width: 20%">jenis kelamin</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ ParseJenisKelaminSurat(PasienSex) }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fw-600" style="width: 20%">alamat</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ PasienAddress }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fw-600" style="width: 20%">lokasi pemeriksaan</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ ExaminedClinic }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fw-600" style="width: 20%">tanggal pemeriksaan</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ ExaminedDate }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fw-600" style="width: 20%">dokter yang memeriksa</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ ExaminedDoctor }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fw-600" style="width: 20%">anamnesis</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <span class="pasien-anamnesa" v-html="PasienAnamnesa"></span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fw-600" style="width: 20%">pemeriksaan fisik</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">&nbsp;</span>
                                <div></div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize fw-600 pl-3-5 v-top" style="width: 20%;">organ</td>
                            <td>
                                <span class="mr-4 v-top">:</span>
                                <img v-if="checkValueData(PemeriksaanFisikDraw)" :src="PemeriksaanFisikDraw" alt="organ">
                                <span v-else>Tidak Diperiksa</span>
                            </td>
                        </tr>
                        <tr v-if="checkValueData(PemeriksaanFisikNote)">
                            <td class="text-capitalize fw-600 pl-3-5" style="width: 20%;">&nbsp;</td>
                            <td class="d-flex align-items-center">
                                <p class="mx-4">Keterangan:</p>
                                <span v-html="PemeriksaanFisikNote"></span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize fw-600 pl-3-5" style="width: 20%;">berat badan</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div v-if="PasienWeight && PasienWeight > 0">{{ PasienWeight }} kg</div>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize fw-600 pl-3-5" style="width: 20%;">tinggi badan</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div v-if="PasienHeight && PasienHeight > 0">{{ PasienHeight }} cm</div>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize fw-600 pl-3-5" style="width: 20%;">tekanan darah</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div v-if="(PasienSystole && PasienSystole > 0) && (PasienDiastole && PasienDiastole > 0)">
                                    {{ PasienSystole }}/{{ PasienDiastole }} mmHg</div>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize fw-600 pl-3-5" style="width: 20%;">nadi</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div v-if="PasienPulse && PasienPulse > 0">{{ PasienPulse }}x/menit</div>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize fw-600 pl-3-5" style="width: 20%;">respirasi</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div v-if="PasienRespiration && PasienRespiration > 0">{{ PasienRespiration }}x/menit</div>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize fw-600 pl-3-5" style="width: 20%;">suhu</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div v-if="PasienTemperature && PasienTemperature > 0">{{ PasienTemperature }} Celcius</div>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize fw-600 pl-0" style="width: 20%">diagnosa</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div class="row w-100">
                                    <div class="col-6">
                                        <span>{{ Diagnose }}</span>
                                    </div>
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-4 align-items-center d-flex">
                                                <p class="mb-0 fw-600">Kode ICD
                                                </p>
                                            </div>
                                            <div class="col-8 d-flex align-items-center">
                                                <span class="mx-2 mb-0">:</span>
                                                <p class="mb-0">{{ DiagnoseICDCode }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize fw-600 pl-0" style="width: 20%">pengobatan</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ Prescription }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 20%"></td>
                            <td>
                                <template v-if="CurrentlyPrintingLetter">
                                    <span class="ml-2" style="padding-left: 20px">
                                        {{ RemarksPrescription }}
                                    </span>
                                </template>
                                <template v-else>
                                    <validation-provider rules="" v-slot="{ errors }" tag="div">
                                        <div class="d-flex align-items-center">
                                            <span class="mr-4"></span>
                                            <div class="w-100">
                                                <input v-model="RemarksPrescription" type="text"
                                                    class="w-100 form-control" />
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </div>
                                    </validation-provider>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize fw-600 pl-0" style="width: 20%">tindakan</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ Action }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 20%"></td>
                            <td>
                                <template v-if="CurrentlyPrintingLetter">
                                    <span class="ml-2" style="padding-left: 20px">
                                        {{ RemarksAction }}
                                    </span>
                                </template>
                                <template v-else>
                                    <validation-provider rules="" v-slot="{ errors }" tag="div">
                                        <div class="d-flex align-items-center">
                                            <span class="mr-4"></span>
                                            <div class="w-100">
                                                <input v-model="RemarksAction" type="text" class="w-100 form-control" />
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </div>
                                    </validation-provider>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fw-600" style="width: 20%">tindak lanjut</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div></div>
                            </td>
                        </tr>
                    </table>
                    <b-form-group v-slot="{ ariaDescribedby }" style="margin-bottom: 24px;">
                        <b-form-checkbox-group v-model="SelectedFollowUp" :aria-describedby="ariaDescribedby" stacked
                            @change="EnsureSingleSelection">
                            <b-form-checkbox class="mb-3" value="sembuh">Sembuh</b-form-checkbox>
                            <div class="row d-flex align-items-center mb-3">
                                <div class="col-3 pr-1 d-flex align-items-center">
                                    <b-form-checkbox value="pemeriksaan ulang pada tanggal">
                                        Pemeriksaan ulang pada
                                        tanggal
                                    </b-form-checkbox>
                                </div>
                                <div class="col-9">
                                    <template v-if="IsPemeriksaanUlangSelected && CurrentlyPrintingLetter">
                                        <span class="ml-2">
                                            {{ RemarksFollowUp }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <validation-provider v-if="IsPemeriksaanUlangSelected" rules="required"
                                            v-slot="{ errors }" tag="div" class="w-25">
                                            <div class="d-flex flex-column">
                                                <date-picker :value-type="SuratDatePickerFormat()" v-model="RemarksFollowUp"
                                                    :format="SuratDatePickerFormat()" type="date" :clearable="false"
                                                    input-class="form-control"></date-picker>
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </validation-provider>
                                    </template>
                                </div>
                            </div>
                            <div class="row d-flex align-items-center mb-3">
                                <div class="col-3 pr-1">
                                    <b-form-checkbox value="dirujuk ke">Dirujuk ke</b-form-checkbox>
                                </div>
                                <div class="col-8">
                                    <template v-if="IsDiRujukKeSelected && CurrentlyPrintingLetter">
                                        <span class="ml-2">
                                            {{ RemarksFollowUp }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <validation-provider v-if="IsDiRujukKeSelected" rules="required" v-slot="{ errors }"
                                            tag="div" class="w-50">
                                            <div class="d-flex align-items-center">
                                                <div class="w-100">
                                                    <input v-model="RemarksFollowUp" type="text" class="form-control" />
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </div>
                                        </validation-provider>
                                    </template>
                                </div>
                            </div>
                            <div class="row align-items-center mb-3">
                                <div class="col-3 pr-1">
                                    <b-form-checkbox value="dirawat di">Dirawat di</b-form-checkbox>
                                </div>
                                <div class="col-9">
                                    <template v-if="IsDirawatDiSelected && CurrentlyPrintingLetter">
                                        <span class="ml-2">
                                            {{ RemarksFollowUp }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <validation-provider v-if="IsDirawatDiSelected" rules="required" v-slot="{ errors }"
                                            tag="div" class="w-50">
                                            <div class="d-flex align-items-center">
                                                <div class="w-100">
                                                    <input v-model="RemarksFollowUp" type="text"
                                                        class="w-100 form-control" />
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </div>
                                        </validation-provider>
                                    </template>
                                </div>
                            </div>

                        </b-form-checkbox-group>
                    </b-form-group>
                </div>
            </div>
        </div>


        <div class="col-12 mt-3">
            <div class="row">
                <div class="col-12">
                    <p style="margin-bottom: 3px">{{ KlinikInformation.KlinikCity }}, {{ SuratDate() }}</p>
                </div>
                <div class="col-12">
                    <p class="text-capitalize">jam: {{ SuratDateTimeRecorded }}</p>
                </div>
                <div class="col-12 mt-4 mb-2">
                    <p>Dokter yang memeriksa,</p>
                </div>
                <div class="col-12 mt-4 pt-4">
                    <p class="mb-1">{{ DokterInformation.DokterName }}</p>
                    <p>{{ DokterInformation.DokterSIP }}</p>
                </div>
            </div>
        </div>

        <div class="col-12">
            <SuratPenunjangFormBaseDigitalSign />
        </div>
    </div>
</template>

<script>
import "vue2-datepicker/index.css";
import { mapState, mapGetters, mapMutations } from 'vuex'
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: 'This field is required'
});

import { SuratDate, SuratDateTime, SuratDatePicker, SuratDatePickerFormat, SuratPersetujuanDate, SuratDateExaminedFormat } from '../../Helpers/DateSurat.js'
import { ParseJenisKelaminSurat } from '../../Helpers/ParseJenisKelaminSurat.js'
import { OnlyNumericCommaAndDotInputOnKeypress } from '../../Helpers/InputEvent.js'

export default {
    name: 'SuratResumeMedisBody',
    components: {
        DatePicker: () => import('vue2-datepicker'),
        SuratPenunjangFormBaseDigitalSign: () => import('../Base/SuratPenunjangFormBaseDigitalSign.vue')
    },
    data() {
        return {
            PasienName: null,
            PasienAge: null,
            PasienMRN: null,
            PasienDateBirth: null,
            PasienSex: null,
            PasienAddress: null,
            ExaminedClinic: null,
            ExaminedDate: null,
            ExaminedDoctor: null,
            PasienAnamnesa: null,
            PasienWeight: null,
            PasienHeight: null,
            PasienDiastole: null,
            PasienSystole: null,
            PasienPulse: null,
            PasienRespiration: null,
            PasienTemperature: null,
            Diagnose: null,
            DiagnoseICDCode: null,
            ICDCode: null,
            Prescription: null,
            RemarksPrescription: null,
            Action: null,
            RemarksAction: null,
            SelectedFollowUp: [],
            RemarksFollowUp: null,
            SuratDateTimeRecorded: null,
            PemeriksaanFisikDraw: null,
            PemeriksaanFisikNote: null,
        }
    },
    watch: {
        PasienInformation: {
            handler: function (val) {
                if (val && Object.keys(val).length > 0 && !this.LetterID) {
                    Object.keys(val).map(key => {
                        if (this[key] !== undefined) {
                            let tmpVal = val[key]
                            this.$set(this, key, tmpVal)
                        }
                    })

                    this.$nextTick(() => {
                        this.SetPasienDiagnoseICD('kode')
                        this.SetPasienDiagnoseICD('description')
                        this.SetKlinikInformation()
                    })
                }
            },
            deep: true,
            immediate: true
        },
        SelectedFollowUp: {
            handler: function () {
                this.RemarksFollowUp = null
            },
            deep: true,
            immediate: true
        },
        TataLaksanaPenunjang: {
            handler: function (val) {
                if (val) {
                    this.$nextTick(() => {
                        this.SetObat()
                        this.SetTindakan()
                    })
                }
            },
            deep: true,
            immediate: true
        },
        pemeriksaanNote: {
            handler: function (val) {
                if (this.$route.fullPath.includes('/klinik/rekam-medis')) {
                    this.PemeriksaanFisikNote = this.checkValueData(val) ? val : null;
                }
            },
            deep: true,
            immediate: true
        },
        pemeriksaanDraw: {
            handler: function () {
                if (this.$route.fullPath.includes('/klinik/rekam-medis')) {
                    let rm = this.rekamMedis;
                    if (this.checkValueData(rm.postData.organ_id)) {
                        let organ = rm.canvas_pemeriksaan;
                        this.PemeriksaanFisikDraw = this.checkValueData(organ) ? organ.toDataURL('image/png') : null;
                    } else this.PemeriksaanFisikDraw = null;
                }
            },
            deep: true,
            immediate: true
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.$emit('ComponentMounted')
            this.TanggalPemeriksaan = SuratDatePicker()
            this.SuratDateTimeRecorded = this.SuratDateTime()
        })
    },
    computed: {
        ...mapState(['rekamMedis', 'rm']),
        ...mapState('SuratPenunjangStore', ['CurrentlyPrintingLetter', 'PasienInformation', 'KlinikInformation', 'DokterInformation', 'TransKlinikIDFromPembayaran', 'LetterID', 'TataLaksanaPenunjang', 'AtPembayaranPage', 'LetterNumber']),
        ...mapGetters('SuratPenunjangStore', ['API_URL', 'PekerjaanSurat', 'GolonganDarahSurat', 'ButaWarnaSurat', 'TransKlinikID']),
        ...mapGetters('rm', ['pemeriksaanNote', 'pemeriksaanDraw']),
        ValueSelectedFollowUp() {
            return this.SelectedFollowUp[0]
        },
        IsSembuhSelected() {
            return this.ValueSelectedFollowUp === 'sembuh'
        },
        IsPemeriksaanUlangSelected() {
            return this.ValueSelectedFollowUp === 'pemeriksaan ulang pada tanggal'
        },
        IsDiRujukKeSelected() {
            return this.ValueSelectedFollowUp === 'dirujuk ke'
        },
        IsDirawatDiSelected() {
            return this.ValueSelectedFollowUp === 'dirawat di'
        },
        SuratResumeMedis() {
            return `${this.API_URL}/surat-resume-medis`
        },
        PayloadBackend() {
            return {
                namaPasien: this.PasienName,
                umurPasien: this.PasienAge,
                nomorRekamMedisPasien: this.PasienMRN,
                tanggalLahirPasien: this.PasienDateBirth,
                jenisKelaminPasien: this.PasienSex,
                alamatPasien: this.PasienAddress,
                lokasiPemeriksaanPasien: this.ExaminedClinic,
                tanggalPemeriksaanPasien: this.ExaminedDate,
                dokterYangMemeriksaPasien: this.ExaminedDoctor,
                anamnesaPasien: this.PasienAnamnesa,
                beratBadanPasien: this.PasienWeight,
                tinggiBadanPasien: this.PasienHeight,
                sistolePasien: this.PasienSystole,
                diastolePasien: this.PasienDiastole,
                nadiPasien: this.PasienPulse,
                respirasiPasien: this.PasienRespiration,
                suhuPasien: this.PasienTemperature,
                diagnosaPasien: this.Diagnose,
                kodeIcdPasien: this.DiagnoseICDCode,
                pengobatanPasien: this.Prescription,
                detailPengobatanPasien: this.RemarksPrescription,
                tindakanPasien: this.Action,
                detailTindakanPasien: this.RemarksAction,
                tindakLanjutPasien: this.SelectedFollowUp.length > 0 ? this.SelectedFollowUp[0] : null,
                detailTindakLanjutPasien: this.RemarksFollowUp,
                jamSurat: this.SuratDateTimeRecorded,
                kotaSurat: this.KlinikInformation.KlinikCity,
                tanggalSurat: this.SuratDate(),
                transKlinikId: !this.AtPembayaranPage ? this.TransKlinikID : this.TransKlinikIDFromPembayaran,
                nomorSurat: this.LetterNumber,
                pemeriksaanDraw: this.PemeriksaanFisikDraw,
                pemeriksaanNote: this.PemeriksaanFisikNote,
            }
        },
    },
    methods: {
        ...mapMutations(['SET_LOADING']),
        ...mapMutations('SuratPenunjangStore', ['SetLetterNumber']),
        SuratDatePickerFormat,
        ParseJenisKelaminSurat,
        SuratDate,
        SuratDateTime,
        SuratPersetujuanDate,
        OnlyNumericCommaAndDotInputOnKeypress,
        ProxyDatePickerDisabledNextDate(DateValue, CurrentDateValue) {
            return SuratDatePickerDisabledNextDate(this.EndSickPeriode, DateValue)
        },
        ProxyDatePickerDisabledPreviousDate(DateValue, CurrentDateValue) {
            return SuratDatePickerDisabledPreviousDate(this.StartSickPeriode, DateValue)
        },
        EnsureSingleSelection(NewValue) {
            if (NewValue.length > 0) {
                const [FirstValue, LastValue] = NewValue;
                if (NewValue.length === 1) {
                    this.SelectedFollowUp = [FirstValue];
                } else {
                    this.SelectedFollowUp = [LastValue]
                }
            } else {
                this.SelectedFollowUp = [];
            }

        },
        SetPasienDiagnoseICD(type) {
            let tmpDiagnose = []
            if (this.rekamMedis.postData.kode_penyakit_primary && this.rekamMedis.postData.kode_penyakit_primary.kode) {
                tmpDiagnose.push(this.rekamMedis.postData.kode_penyakit_primary);
            }
            if (this.rekamMedis.postData.kode_penyakit && this.rekamMedis.postData.kode_penyakit.length > 0) {
                this.rekamMedis.postData.kode_penyakit.forEach((item) => {
                    tmpDiagnose.push(item);
                });
            }
            if (this.rekamMedis.postData.odontogram_icdx && this.rekamMedis.postData.odontogram_icdx.length > 0) {
                this.rekamMedis.postData.odontogram_icdx.forEach((item) => {
                    item.forEach(v => {
                        tmpDiagnose.push(v);
                    });
                });
            }
            if (type === 'kode') this.DiagnoseICDCode = tmpDiagnose.map(item => item.kode).join(', ');
            else this.Diagnose = tmpDiagnose.map(item => item.description).join(', ');
        },
        MapPrescriptionAndActions(target = 'obat') {
            if (this.TataLaksanaPenunjang && this.TataLaksanaPenunjang.length > 0) {
                return this.TataLaksanaPenunjang.map(item => {
                    if (item.kategori_layanan && item.kategori_layanan.toLowerCase() === target) {
                        return `${item.quantity}x ${item.nama_layanan}`
                    } else {
                        return null
                    }
                }).filter(item => item).join(', ')
            } else if (this.rekamMedis.postData.tatalaksana && this.rekamMedis.postData.tatalaksana.length > 0) {
                return this.rekamMedis.postData.tatalaksana.map(item => {
                    if (item.kategori_layanan && item.kategori_layanan.toLowerCase() === target) {
                        return `${item.quantity}x ${item.nama_layanan}`
                    } else {
                        return null
                    }
                }).filter(item => item).join(', ')
            }
        },
        SetObat() {
            this.Prescription = this.MapPrescriptionAndActions('obat')
        },
        SetTindakan() {
            this.Action = this.MapPrescriptionAndActions('tindakan')
        },
        SetKlinikInformation() {
            this.ExaminedClinic = this.KlinikInformation.KlinikName
            this.ExaminedDate = SuratDateExaminedFormat()
            this.ExaminedDoctor = this.DokterInformation.DokterName
        },
        async GetData() {
            this.SET_LOADING(true)

            this.$nextTick(async () => {
                const { data } = await this.$axios.get(`${this.SuratResumeMedis}/${this.LetterID}`);

                this.PasienName = data.nama_pasien
                this.PasienAge = data.umur_pasien
                this.PasienMRN = data.nomor_rekam_medis_pasien
                this.PasienDateBirth = data.tgl_lahir_pasien
                this.PasienSex = data.jenis_kelamin_pasien
                this.PasienAddress = this.checkValueData(data.alamat_pasien) ? data.alamat_pasien : ''
                this.ExaminedClinic = data.lokasi_pemeriksaan_pasien
                this.ExaminedDate = data.tgl_pemeriksaan_pasien
                this.ExaminedDoctor = data.dokter_yang_memeriksa_pasien
                this.PasienAnamnesa = data.anamnesa_pasien
                this.PasienWeight = data.berat_badan_pasien
                this.PasienHeight = data.tinggi_badan_pasien
                this.PasienDiastole = data.diastole_pasien
                this.PasienSystole = data.sistole_pasien
                this.PasienPulse = data.nadi_pasien
                this.PasienRespiration = data.respirasi_pasien
                this.PasienTemperature = data.suhu_pasien
                this.Diagnose = data.diagnosa_pasien
                this.DiagnoseICDCode = data.kode_icd_pasien
                this.Prescription = data.pengobatan_pasien
                this.RemarksPrescription = data.detail_pengobatan_pasien
                this.Action = data.tindakan_pasien
                this.RemarksAction = data.detail_tindakan_pasien

                if (this.checkValueData(data.pemeriksaan_note)) this.PemeriksaanFisikNote = data.pemeriksaan_note
                if (this.checkValueData(data.pemeriksaan_draw)) this.PemeriksaanFisikDraw = data.pemeriksaan_draw

                this.$nextTick(() => {
                    this.SelectedFollowUp = data.tindak_lanjut_pasien ? [data.tindak_lanjut_pasien] : []

                    this.$nextTick(() => {
                        this.RemarksFollowUp = data.detail_tindak_lanjut_pasien
                    })
                })

                this.SuratDateTimeRecorded = data.jam_surat

                this.SetLetterNumber(data.nomor_surat)

                this.$nextTick(() => {
                    this.SET_LOADING(false)
                })
            })
        },
        async UpdateData() {
            const { data } = await this.$axios.put(`${this.SuratResumeMedis}/${this.LetterID}`, this.PayloadBackend);
            return data;
        },
        async SaveData() {
            const { data } = await this.$axios.post(`${this.SuratResumeMedis}/create`, this.PayloadBackend);
            return data;
        },
    }
}
</script>

<style lang="scss">
.surat-resume-medis {
    .table {
        td {
            padding-top: 0;
            padding-bottom: 14px;
        }
    }
}
.fw-600 {
    font-weight: 600;
}
.pl-3-5 {
    padding-left: 35px;
}
.v-top {
    vertical-align: top !important;
}
</style>